'use client';

import { Box, Typography, useTheme } from '@mui/material';
import { LockOutlinedIcon } from '@/components/icons';
import { INTAKE_LOCKED_COMPOSER_TEXT } from '../intake-form/intake-copy';

/** Locked composer strip shown while the mandatory intake form is visible. */
export function IntakeLockedComposer() {
  const theme = useTheme();

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        width: '100%',
        minHeight: 48,
        px: 2,
        py: 1.5,
        borderRadius: 2,
        bgcolor: theme.palette.grey[100],
        border: `1px solid ${theme.palette.grey[300]}`,
        color: theme.palette.text.secondary,
      }}
    >
      <LockOutlinedIcon fontSize="small" aria-hidden />
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {INTAKE_LOCKED_COMPOSER_TEXT}
      </Typography>
    </Box>
  );
}
